var highContrastMediaQuery = theme => {
  return (theme === null || theme === void 0 ? void 0 : theme.mode) === 'contrast' ? {
    '@media (-ms-high-contrast: active), (forced-colors: active)': {
      forcedColorAdjust: 'none',
      msHighContrastAdjust: 'none'
    }
  } : {};
};
export default highContrastMediaQuery;